export default __webpack_public_path__ + "static/media/aboutCEO.1e2103e8.jpg";